import { MainBannerProps, MainBannerEditorProps, BannerItem } from './MainBanner.types';

/**
 * 기존 MainBanner 데이터 형식을 새로운 형식으로 변환
 * 
 * @param originalProps 기존 MainBanner 컴포넌트의 props
 * @returns 변환된 새로운 MainBanner 컴포넌트용 props
 */
export function adaptMainBannerProps(originalProps: any): MainBannerProps {
  // 기본값 설정
  const originalContent = originalProps?.content || {};
  const originalData = originalProps?.data || {};
  const originalComponentProps = originalProps?.componentProps || {};
  
  // mode 속성 추출
  const mode = originalProps?.mode || originalComponentProps?.mode || 'slider';
  
  // 스타일 병합 (깊은 복사로 병합)
  const style = {
    ...(originalProps?.style || {}),
    ...(originalComponentProps?.style || {}),
  };
  
  // 인라인 스타일과 CSS 클래스 통합
  if (originalProps.defaultStyle) {
    Object.assign(style, originalProps.defaultStyle);
  }

  // className 설정
  const className = originalProps?.className || originalComponentProps?.className || '';

  // 배너 데이터 찾기 (다양한 위치에서 확인)
  let banners: BannerItem[] = [];

  // 1. 직접 전달된 banners 배열
  if (originalProps?.banners && Array.isArray(originalProps.banners)) {
    banners = [...originalProps.banners];
  } 
  // 2. componentProps 객체 내의 banners 배열
  else if (originalComponentProps?.banners && Array.isArray(originalComponentProps.banners)) {
    banners = [...originalComponentProps.banners];
  }
  // 3. data 객체 내의 banners 배열
  else if (originalData?.banners && Array.isArray(originalData.banners)) {
    banners = [...originalData.banners];
  }
  // 4. content 객체 내의 banners 배열
  else if (originalContent?.banners && Array.isArray(originalContent.banners)) {
    banners = [...originalContent.banners];
  }

  // 디바이스별 속성 확인 (originalProps, componentProps, content 모두 확인)
  const deviceProperty = originalProps?.deviceProperty || 
                         originalComponentProps?.deviceProperty || 
                         originalContent?.deviceProperty;

  // 변환된 props 반환
  const adaptedProps: MainBannerProps = {
    id: originalProps?.id || '',
    style,
    className,
    mode,
    banners,
    content: {
      ...originalContent,
      banners,
      deviceProperty
    },
    componentProps: {
      ...originalComponentProps,
      mode,
      banners
    },
    data: originalData,
    addBanner: originalProps?.addBanner,
    updateBanner: originalProps?.updateBanner,
    updateIndex: originalProps?.updateIndex,
    updateStyle: originalProps?.updateStyle,
    updatedBanners: originalProps?.updatedBanners
  };

  // 원본 props의 모든 속성 중 이미 처리한 속성 제외하고 나머지 복사
  const excludeKeys = ['content', 'style', 'className', 'data', 'componentProps', 'id', 
                      'banners', 'mode', 'addBanner', 'updateBanner', 'updateIndex', 
                      'updateStyle', 'updatedBanners', 'deviceProperty'];
  
  Object.keys(originalProps).forEach(key => {
    if (!excludeKeys.includes(key)) {
      adaptedProps[key] = originalProps[key];
    }
  });

  return adaptedProps;
}

/**
 * 기존 MainBanner 데이터 형식을 에디터 컴포넌트용으로 변환
 * 
 * @param originalProps 기존 MainBanner 컴포넌트의 props
 * @returns 변환된 에디터 컴포넌트용 props
 */
export function adaptMainBannerEditorProps(originalProps: any): MainBannerEditorProps {
  // 기본 props 변환 사용
  const adaptedProps = adaptMainBannerProps(originalProps);
  
  // 에디터 관련 추가 props
  return {
    ...adaptedProps,
    isSelected: originalProps.isSelected || false,
    isPreview: originalProps.isPreview || false,
    viewMode: originalProps.viewMode || 'pc',
    updateComponent: originalProps.updateComponent || (() => {})
  };
} 